import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import CloseIcon from '../../../common/Icons/CloseIcon';
import { useAppSelector } from '../../../store/hook';
import { useShopDataModalContext } from '../ShopDataModalContext';
import { testIdFormattedLabel } from '../testIdUtils';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px;
  line-height: normal;
  border-bottom: 1px solid var(--line-gray);
  &:not(:first-child) {
    border-top: 1px solid var(--line-gray);
  }

  &.borderless {
    border: none;
  }
`;

const Info = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
`;

const Actions = styled.div`
  display: flex;
`;

const DeleteAction = styled.div`
  cursor: pointer;
`;

const Title = styled.div`
  font-family: var(--font-bold);
  font-size: 20px;
  color: var(--text-primary);
`;

const LivingTypeLabel = styled.span`
  font-size: 14px;
  color: var(--text-secondary);
`;

interface Props {
  label: string;
  borderless?: boolean;
  onDelete?: () => void;
}

const ShopDataModalCategoryHeader = ({ label, borderless, onDelete }: Props) => {
  const careTypes = useAppSelector((state) => state.global.livingTypes);
  const { currentTab } = useShopDataModalContext();

  const livingType = careTypes.find((item) => item.id === Number(currentTab));
  const showDelete = typeof onDelete === 'function';
  return (
    <Header className={classNames({ borderless })}>
      <Info>
        <Title data-test-id={`sd-modal-${testIdFormattedLabel(label)}-label`}>{label}</Title>
        {Boolean(livingType) && (
          <>
            <span>·</span>
            <LivingTypeLabel>{livingType?.type}</LivingTypeLabel>
          </>
        )}
      </Info>
      <Actions>
        {showDelete && (
          <DeleteAction onClick={onDelete}>
            <CloseIcon size={16} />
          </DeleteAction>
        )}
      </Actions>
    </Header>
  );
};

export default ShopDataModalCategoryHeader;
